import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SlideUpComponentStyles from './SlideUpComponentStyles';
import { ReactSVG } from 'react-svg';

const SlideUpComponent = ({ active, children, close, hideCloseButton = false, onBack = false }) => (
  <SlideUpComponentStyles className={active && 'active'}>
    <div className="children-wrapper">
      {onBack && (
        <ReactSVG className='back-btn' src="/static/images/icons/scheduler/back-new.svg?type=svg" onClick={onBack} />
      )}
      {!hideCloseButton && (
        <button type="button" className="close-btn" onClick={close}>
          <FontAwesomeIcon icon={faTimes} color="#333"></FontAwesomeIcon>
        </button>
      )}
      {children}
    </div>
  </SlideUpComponentStyles>
);

export default SlideUpComponent;
